// @flow

//
// React
//
import React from 'react';

import {
    createItemSubItemCellRenderer,
} from '../../../trix-web-components-table';

const createPersonTableColumn = (cfg: any): any => {
    return {
        align: 'left',
        flex: true,
        width: 200,

        renderCell: createItemSubItemCellRenderer({
            ...cfg.cellRendererFactoryProps,

            getItem: (props: any) => {
                return (props.value) ? props.value.idNo : '';
            },

            getSubItem: (props: any) => {
                if (props.value) {
                    return `${props.value.firstName} ${props.value.middleName} ${props.value.lastName}`;
                } else {
                    return (<i>Not defined</i>);
                }
            }
        })
    }
}
export default createPersonTableColumn;